import Mapbox from 'index.vue';
import { BaseRasterLayer } from './baseRasterLayer';
export class TilesLayer extends BaseRasterLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        super(mapboxInstance,'middle'); 
    }
    public DataChanged = async () => {
        this.RemoveAllLayers();
        this.mapboxInstance.model.areaSets.forEach((areaSet: any) => {
            if (this.mapboxInstance.areaSetVisible == areaSet.id && !areaSet.hover) {
                const regex = /([^0-9a-zA-Z]+)/g;
                const areaSetBlobName = areaSet.name.replace(regex, '-').toLowerCase();
                const tileUrl = `/api/tile-proxy/${areaSetBlobName}/{z}/{x}/{y}`;
                this.AddLayer(areaSet.id, tileUrl, areaSet.mapTilesZoomLevelsAvailable);
            }
        });
    };
}